import {FIELD_TYPE} from "types/enums";
const {INPUT, SELECT, DATE, NUMBER} = FIELD_TYPE;
const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 6};
const fieldsVital = (name): any => [
  // {
  //   type: INPUT,
  //   label: "Nhịp thở",
  //   name: ["vitalSigns", "RR"],
  //   addonAfter: "lần/phút",
  // },
  // {
  //   type: INPUT,
  //   label: "Mạch",
  //   name: ["vitalSigns", "Pulse"],
  //   addonAfter: "lần/phút",
  // },
  // {
  //   type: INPUT,
  //   label: "Huyết áp",
  //   name: ["vitalSigns", "BloodPressure"],
  //   addonAfter: "mmHG",
  // },
  {
    type: NUMBER,
    label: "Cân nặng",
    name: ["vitalSigns", "Weight"],
    addonAfter: "kg",
    css: css,
  },
  {
    type: NUMBER,
    label: "Chiều cao",
    name: ["vitalSigns", "Height"],
    addonAfter: "cm",
    css: css,
  },

  {
    type: NUMBER,
    label: "BMI",
    name: ["vitalSigns", "BMI"],
    disable: true,
    css: css,
  },
  // {
  //   type: INPUT,
  //   label: "Nhiệt độ",
  //   name: ["vitalSigns", "Temperature"],
  //   addonAfter: "℃",
  // },

  // {
  //   type: INPUT,
  //   label: "Sp02",
  //   name: ["vitalSigns", "Sp02"],
  //   addonAfter: "%",
  // },

  {
    type: INPUT,
    label: "Ghi chú",
    name: ["vitalSigns", "Comment"],
    css: css,
  },
];
const listMethodIntraocularPressure = [
  {value: "Perkins", label: "Perkins"},
  {value: "AT", label: "Đè dẹt (AT)"},
  {value: "NCT", label: "Không tiếp xúc (NCT)"},
  {value: "Schiotz", label: "Schiotz"},
  {value: "Máy đo nhãn áp hơi", label: "Máy đo nhãn áp hơi"},
];
const listWarningPunctumSyringing = ["Roplas(-)", "Thông tốt"];
const listPunctumSyringing = position => {
  return [
    {value: "Roplas(+)", label: "Roplas(+)"},
    {value: "Roplas(-)", label: "Roplas(-)"},
    {value: "Thông tốt", label: "Thông tốt"},
    {value: "Không thấy điểm lệ", label: "Không thấy điểm lệ"},
    {
      value: "Bán tắc với dịch trong trào tại chỗ",
      label: "Bán tắc với dịch trong trào tại chỗ",
    },
    {
      value: `Bán tắc với dịch trong trào điểm lệ đạo ${position}`,
      label: `Bán tắc với dịch trong trào điểm lệ đạo ${position} `,
    },
    {
      value: "Tắc với dịch trong trào tại chỗ",
      label: "Tắc với dịch trong trào tại chỗ",
    },
    {
      value: `Tắc với dịch trong trào điểm lệ ${position}`,
      label: `Tắc với dịch trong trào điểm lệ ${position}`,
    },
    {
      value: "Tắc trào dịch nhầy",
      label: "Tắc trào dịch nhầy",
    },
    {
      value: "Tắc trào dịch mủ",
      label: "Tắc trào dịch mủ",
    },
    {value: "Lỗ rò lệ đạo", label: "Lỗ rò lệ đạo"},
  ];
};
export {
  fieldsVital,
  listMethodIntraocularPressure,
  listPunctumSyringing,
  listWarningPunctumSyringing,
};
